<div class="dropdown-container relative">
  <!-- Input Field -->
  <input type="text" [placeholder]="placeholder" [value]="selectedYear || initialValue" readonly inputmode="none"
    (click)="toggleCalendar()"
    [ngClass]="asahi 
           ? 'w-full h-[64.577px] px-[30.492px] py-[22.869px] rounded-[50px] border-[1.906px] border-[rgba(117,125,138,0.32)] text-[#757D8A] appearance-none cursor-pointer' 
           : 'bg-[#121212] px-4 py-4 pr-12 border border-[#3C3C3C99] rounded-lg focus:outline-none focus:ring-2 focus:ring-secondary w-full text-slate-300 text-lg appearance-none cursor-pointer'" />

  <!-- Calendar Icon -->
  <div *ngIf="showIcon" class="top-1/2 right-3 absolute flex items-center -translate-y-1/2 cursor-pointer"
    (click)="toggleCalendar()">
    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
      stroke-linecap="round" stroke-linejoin="round" class="text-slate-400 hover:text-slate-300 transition-colors">
      <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
      <line x1="16" y1="2" x2="16" y2="6"></line>
      <line x1="8" y1="2" x2="8" y2="6"></line>
      <line x1="3" y1="10" x2="21" y2="10"></line>
    </svg>
  </div>

  <!-- Year Picker -->
<div *ngIf="showCalendar && active === 'calender'" [ngClass]="asahi 
    ? 'top-full right-0 absolute z-50 bg-white shadow-xl mt-2 p-4 border-t-4 border-pink-500 rounded-lg w-96' 
    : 'top-full left-0 absolute z-50 bg-black shadow-xl mt-2 p-4 border-t-4 border-pink-500 rounded-lg w-80'">
    <!-- Header -->
    <div class="flex justify-between items-center mb-4">
      <h3 [ngClass]="asahi? 'font-semibold text-gray-800 text-lg':'font-semibold text-white text-lg'">{{ 'Select Year' | translate }}</h3>
    <div class="flex gap-2">
      <button type="button" (click)="changeYearRange(-1); $event.stopPropagation()"
        [ngClass]="asahi ? 'p-2 text-gray-500 hover:text-black' :'p-2 text-gray-300 hover:text-white'">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="15,18 9,12 15,6"></polyline>
        </svg>
      </button>
    
      <button type="button" (click)="changeYearRange(1); $event.stopPropagation()"
        [ngClass]="asahi ? 'p-2 text-gray-500 hover:text-black' :'p-2 text-gray-300 hover:text-white'">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <polyline points="9,18 15,12 9,6"></polyline>
        </svg>
      </button>
    </div>

    </div>

    <!-- Year Grid -->
  <div class="grid grid-cols-4 gap-2">
    <button *ngFor="let year of visibleYears" type="button" (click)="selectYear(year)" class="transition" [ngClass]="asahi
        ? (selectedYear === year
            ? 'border-2 border-green-500 text-green-600 font-semibold w-22 h-10 rounded-[10.5rem]'
            : 'text-gray-800 hover:bg-gray-100 rounded-full px-6 py-2')
        : (selectedYear === year
            ? 'border-2 border-green-500 text-green-600 font-semibold w-22 h-10 rounded-[10.5rem]'
            : 'text-white hover:rounded-full px-6 py-2')">
      {{ year }}
    </button>
  </div>
  </div>
</div>

